import Hotjar from '@hotjar/browser'

const siteId = 3915846
const hotjarVersion = 6

import { debounce } from '../utils/timeUtils'

if (window.appData.env === 'production') {
  const userId = window.appData?.user?.id || 'anonymous'

  Hotjar.init(siteId, hotjarVersion, {
    debug: true
  })

  if (userId) {
    Hotjar.identify(userId, {})
  }

  const handlePageChange = debounce((pathname, eventType) => {
    console.log(`Page change: ${pathname} ${eventType}`)
    Hotjar.stateChange(pathname)
  }, 200)

  document.addEventListener('turbo:load', () => {
    handlePageChange(window.location.pathname, 'turbo:load')
  })

  document.addEventListener('turbo:frame-load', (event) => {
    const pathname = new URL(event.target?.src || window.location.href).pathname
    handlePageChange(pathname, 'turbo:frame-load')
  })
}
